'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _th_TH = require('../locale/th_TH');

var _th_TH2 = _interopRequireDefault(_th_TH);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _th_TH2['default'];